// extracted by mini-css-extract-plugin
export default {"calendarEventNormal":"NormalCalendarEvent_calendarEventNormal__X0PeQ","iconText":"NormalCalendarEvent_iconText__i4mIz"};